import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import AppErrorBoundary from './components/AppErrorBoundary';
import AppStartupGuard from './components/AppStartupGuard';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppErrorBoundary>
      <AppStartupGuard>
        <App />
      </AppStartupGuard>
    </AppErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();

// Service worker registration removed (PWA disabled). Web push is handled in src/firebase.js.
